import styled from 'styled-components';
import { XIShadowsDown, XIColors } from '@inmoment/the-kitchen';

interface VisualTileWrapperType {
  color?: string;
}

export const VisualTileWrapper = styled.div`
  box-sizing: border-box;
  min-height: 144px;
  min-width: 144px;
  background: ${(props: VisualTileWrapperType) => (props.color === 'white' ? XIColors.white.primary : XIColors.orca.primary)};
  cursor: pointer;
  border: 1px solid ${XIColors.grey.light[80]};
  padding: 24px;
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  flex: 1 0 1;
  transition: all 0.1s;
  margin: -1px 0 0 -1px;
  &:hover {
    transform: scale(1.1);
    z-index: 999;
    border-radius: 6px;
    box-shadow: ${XIShadowsDown[3]};
  }
  &:active {
    transform: scale(1.05);
    z-index: 999;
    border-radius: 6px;
    box-shadow: ${XIShadowsDown[3]};
  }
`;

export const DownloadButton = styled.div`
  position: absolute;
  top: 3px;
  right: 3px;
  z-index: 10;
  opacity: 0;
  transition: opacity 0.1s;
  ${VisualTileWrapper}:hover && {
    opacity: 1;
  }
`;
